/* @generated */
import * as React from "react";
const defaults = {
  isFlexGap: false
};
const FlexGapContext = React.createContext(defaults);
const useFlexGap = () => {
  const context = React.useContext(FlexGapContext);
  if (context === void 0) {
    return defaults.isFlexGap;
  }
  return typeof context.isFlexGap === "undefined" ? defaults.isFlexGap : context.isFlexGap;
};
export {
  FlexGapContext,
  useFlexGap
};
